import BaseContainer from "@base/container/BaseContainer";
import ParallaxContainer from "./ParallaxContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import gsap from "gsap";
import AxesContainer from "@/containers/AxesContainer";

export default class GameBackgroundContainer extends BaseContainer {

  constructor(data = null) {
    super(data)

    // Signals.forceRoundStart.add(this.reset, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    this.pivot.set(0,0)
    this.init()
  }

  init() {
    const bg = new ParallaxContainer()
    bg.name = "Parallax"
    this.addChild(bg)
  }

  onStart() {
    this.zoomOut()
  }

  onMakeBets() {
    this.zoomIn()
  }

  onRoundEnd() {
    this.zoomIn()
  }

  zoomIn() {
    gsap.to(this.scale, 5, {x:2, y: 2})
    gsap.to(this.pivot, 5, {x: 0, y: 300})
  }

  zoomOut() {
    gsap.to(this.scale, 5, {x: 1, y: 1})
    gsap.to(this.pivot, 5, {x: 0, y: 0})
  }

}
